import { useState } from "react";
import styles from "./MaintenanceScreen.module.css";

interface Props {
  /** Called when the user clicks "Erneut versuchen" */
  onRetry?: () => void;
}

export function MaintenanceScreen({ onRetry }: Props) {
  const [checking, setChecking] = useState(false);

  async function handleRetry() {
    setChecking(true);
    // Give it a second before reloading — may just need a moment
    await new Promise((r) => setTimeout(r, 800));
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <div className={styles.icon}>🔧</div>
        <h1 className={styles.title}>Server aktuell nicht erreichbar</h1>
        <p className={styles.body}>
          Die Verbindung zum Backend konnte nicht hergestellt werden.
          Das kann an einer kurzzeitigen Wartung oder einem Neustart liegen.
        </p>
        <p className={styles.hint}>
          Bitte kurz warten und dann erneut versuchen.
        </p>
        <button
          className={styles.retryBtn}
          onClick={handleRetry}
          disabled={checking}
        >
          {checking ? "Verbinde …" : "Erneut versuchen"}
        </button>
      </div>
    </div>
  );
}
